import Vue from "vue";
const vm = new Vue();

export const getLineAppByShop = async () => {
    return new Promise((resolve, reject) => {
      vm.$http
        .get( vm.$API_URL + `/shop/lineapp`, {
            headers: {
                Token: localStorage.getItem("access_token")
            },
        })
        .then( async (res) => {
            if(res.data.type === "application/json"){
                const error = JSON.parse(await res.data.text());
                if(!error.status){
                    reject(error.error.msg)
                }
            }else if (!res.data.status) {   
                reject(res.data.error);
            }else{
                resolve(res.data.data)
            }
        }).catch((error) => {
            reject(error);
        });
    });
};

export const registerLineApp = async (step , {
    messagingChannelId,
    messagingChannelSecret,
    messagingChannelAccessToken,
    loginChannelId,
    loginChannelSecret
}) => {
    return new Promise((resolve, reject) => {
      vm.$http
        .post( vm.$API_URL + `/shop/register/lineapp`, 
        {
            step: step,
            messaging_channel_id: messagingChannelId,
            messaging_channel_secret: messagingChannelSecret,
            messaging_channel_access_token: messagingChannelAccessToken,
            login_channel_id: loginChannelId,
            login_channel_secret: loginChannelSecret
        },
        {
            headers: {
                Token: localStorage.getItem("access_token")
            },
        })
        .then((res) => {
            if (!res.data.status) {   
                reject(res.data.error);
            }
            resolve(res.data.data)
        }).catch((error) => {
            if (error.response) {
                if (error.response.status == 500) {
                    reject(error.response.data);
                }
            }
            reject(error);
        });
    });
};


export const updateStatusLineApp = async (id , status) => {
    return new Promise((resolve, reject) => {
      vm.$http
        .put( vm.$API_URL + `/shop/lineapp/${id}/status`, 
        {
            status: status
        },
        {
            headers: {
                Token: localStorage.getItem("access_token")
            },
        })
        .then((res) => {
            if (!res.data.status) {   
                reject(res.data.error);
            }
            resolve(res.data.data)
        }).catch((error) => {
            if (error.response) {
                if (error.response.status == 500) {
                    reject(error.response.data);
                }
            }
            reject(error);
        });
    });
};



